import React, { useRef, useEffect, useState } from "react";
import {
  TableHead,
  Grow,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Container,
  Grid,
  Button,
  TextField,
  IconButton,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import {
  getSparePartList,
  saveSparePart,
  getSelectedSparePartList,
} from "../../store/actions/SparePartActions";
import { getSparePartColumns } from "../../common";
import { useDispatch, useSelector } from "react-redux";
import TableButtons from "../../components/Button/TableButtons";
import Modal from "../../components/Modal/Modal";
import SearchBar from "../../components/SearchBar/SearchBar";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import { isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";
import { ArrowBackIos } from "@mui/icons-material";
import { saveSparePartLogs } from "../../api/SparePartApi";
import sparePartTypeEnum from "../../enums/sparePartTypeEnum";
import sparePartActionEnum from "../../enums/sparePartActionEnum";

export default function AddSparePart(props) {
  const location = useLocation();
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();
  const [sortedColumn, setSortedColumn] = useState("");
  const [sortDirection, setSortDirection] = useState(1);
  const [filterText, setFilterText] = useState("");
  const [rows, setRows] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rowsLength, setRowsLength] = useState(0);
  const [changePage, setChangePage] = useState(false);

  const [tempList, setTempList] = useState([]);
  const [pageChangeCheck, setPageChangeCheck] = useState(false);

  const columnVisibilityModelData =
    JSON.parse(localStorage.getItem("columnVisibilityModel")) || {};
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    columnVisibilityModelData
  );

  const { sparePartList, selectedSparePartList } = useSelector(
    ({ SparePart }) => SparePart
  );

  const modifiedSelectedRow = [];

  useEffect(() => {
    let data = {
      taskId: location.state?.taskId,
      type: location.state?.type,
    };

    fetchSparePart();
    dispatch(getSelectedSparePartList(data));
  }, [dispatch]);

  const fetchSparePart = (pageNumber = currentPage, pageSize = rowsPerPage) => {
    let payload = {
      currentPage: pageNumber + 1,
      pageSize: pageSize,
      searchText: filterText,
      propertyName: sortedColumn,
      direction: sortDirection,
    };
    dispatch(getSparePartList(payload));
  };

  useEffect(() => {
    if (sparePartList?.resultObject) {
      setRows(sparePartList?.resultObject?.content);
      setRowsLength(sparePartList?.resultObject.totalCount);
    }
  }, [sparePartList]);

  const [selectedSparePartListState, setSelectedSparePartListState] = useState(
    []
  );
  const [onlyOneSparePartSelectedCheck, setOnlyOneSparePartSelectedCheck] =
    useState(false);
  useEffect(() => {
    if (selectedSparePartList?.resultObject) {
      setSelectedSparePartListState(selectedSparePartList.resultObject);
    }
  }, [selectedSparePartList]);

  useEffect(() => {
    if (selectedSparePartListState) {
      setOnlyOneSparePartSelectedCheck(selectedSparePartListState.length === 1);
      setTempList(
        selectedSparePartListState.map((element) => ({
          id: element.sparePartId,
          materialCode: element.materialCode,
          materialDescription: element.materialDescription,
          stockQuantity: element.amountUsed.toString(),
        }))
      );
      setSelectionModel(
        selectedSparePartListState.map((element) => element.sparePartId)
      );
    }
  }, [selectedSparePartListState]);

  // Pagination
  const HandleChangePage = (event) => {
    setChangePage(true);
    setCurrentPage(event);
    fetchSparePart(event);
  };

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(event);
    sessionStorage.setItem("blt_rowsPerPage", event);
    setCurrentPage(0);
    fetchSparePart(0, event);
  };

  const handleSortDg = (columnName) => {
    setSortedColumn(columnName[0].field);
    setSortDirection(columnName[0].sort === "desc" ? 1 : 0);
    //1 - desc, 0 - asc
    let payload = {
      currentPage: currentPage + 1,
      pageSize: rowsPerPage,
      searchText: filterText,
      propertyName: columnName ? columnName[0].field : "",
      direction: columnName ? (columnName[0].sort === "desc" ? 1 : 0) : 1,
    };
    dispatch(getSparePartList(payload));
  };

  const handleChangeVisibility = (newModel) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem("columnVisibilityModel", JSON.stringify(newModel));
  };

  const renderTableCell = (rowItems) => {
    return rowItems.map((item, index) => {
      return (
        <TableCell
          id={`sp_rowItems_TableCell_${index}_${item.id}`}
          align="center"
        >
          {item.label}
        </TableCell>
      );
    });
  };

  const [selectionModel, setSelectionModel] = useState([]);

  useEffect(() => {
    const selectedRowData = rows.filter((row) =>
      selectionModel?.includes(row.id)
    );

    //to set default value for quantity
    selectedRowData.forEach((item) => {
      modifiedSelectedRow.push({
        id: item.id,
        materialCode: item.materialCode,
        materialDescription: item.materialDescription,
        unit: item.unit,
        stockQuantity: "1",
      });
    });
    setSelectedIds(modifiedSelectedRow);
    //setModifiedRow(modifiedSelectedRow);
  }, [selectionModel]);

  const customToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarDensitySelector />
      </GridToolbarContainer>
    );
  };

  // Delete Modal
  const [isModalOpen, setModalOpen] = useState(false);
  const [deletedRow, setDeletedRow] = useState([]);
  const deleteButtonHandler = (row) => {
    setDeletedRow(row);
    toggleModal();
  };

  const toggleModal = () => {
    setModalOpen((prevState) => !prevState);
  };

  // Delete row
  const deleteHandler = (row) => {
    toggleModal();
    let filteredItems = tempList.filter((item) => item.id !== row.id);
    setSelectionModel(
      selectionModel.filter((selection) => selection !== row.id)
    );
    setTempList(filteredItems);
  };

  const handleQuantityChange = (event, row) => {
    const modifiedSelectedRow = tempList.map((item) => {
      if (item.materialCode === row.materialCode) {
        return {
          ...item,
          stockQuantity: event.target.value,
        };
      }
      return item;
    });
    //setSelectedIds(modifiedSelectedRow);
    //setModifiedRow(modifiedSelectedRow);
    setTempList(modifiedSelectedRow);
  };

  const handleSaveSparePart = () => {
    const data = tempList.map((item) => {
      return {
        sparePartId: item.id,
        amountUsed: item.stockQuantity,
      };
    });

    let payload = {
      taskId: location.state?.taskId,
      sparePartList: data,
      type: location.state?.type,
    };

    const sparePartList = tempList.map(x => ({
      AmountUsed: x.stockQuantity,
      SparePartId: x.id
    }));

    const sparePartLogData = {
      TaskId: location.state?.taskId,
      SparePartList: sparePartList,
      Type: sparePartTypeEnum[location.state?.type],
      PlantId: 0,
      SparePartAction: sparePartActionEnum.SparePartWasUsed
    }

    saveSparePartLogs(sparePartLogData);
    dispatch(saveSparePart(payload));
    setFilterText("");
  };

  const previousSelectedIds = useRef("");

  const [searchCheck, setSearchCheck] = useState(false);

  useEffect(() => {
    // console.log(1)
    if (
      previousSelectedIds.current &&
      Math.abs(previousSelectedIds.current.length - selectedIds.length) === 1 &&
      pageChangeCheck &&
      !onlyOneSparePartSelectedCheck
    ) {
      const selectedIdsOnlyIds = selectedIds.map((element) => element.id);
      const previousSelectedIdsOnlyIds = previousSelectedIds.current.map(
        (element) => element.id
      );
      if (
        selectedIds.length < previousSelectedIds.current.length &&
        (filterText.length === 0 || searchCheck)
      ) {
        const deletedId = previousSelectedIdsOnlyIds.filter(
          (value) => !selectedIdsOnlyIds.includes(value)
        );
        if (!selectionModel.includes(deletedId[0])) {
          console.log("delete");
          setTempList(tempList.filter((x) => x.id !== deletedId[0]));
        }
      } else {
        if (filterText.length !== 0) {
          setSearchCheck(true);
        }

        const addedId = selectedIdsOnlyIds.filter(
          (value) => !previousSelectedIdsOnlyIds.includes(value)
        );
        const selectedElement = selectedIds.filter(
          (element) => element.id === addedId[0]
        );
        const tempListOnlyIds = tempList.map((element) => element.id);
        // console.log(tempListOnlyIds)
        // console.log(selectedElement)
        if (!tempListOnlyIds.includes(selectedElement[0]?.id)) {
          setTempList(tempList.concat(selectedElement));
          console.log("add");
        }
      }
    }

    if (pageChangeCheck === false) {
      setPageChangeCheck(true);
    }
    if (onlyOneSparePartSelectedCheck === true) {
      setOnlyOneSparePartSelectedCheck(false);
    }

    previousSelectedIds.current = selectedIds;
  }, [selectedIds, selectionModel]);

  useEffect(() => {
    setSelectedIds([]);
    let selectedRowsOnPageList = [];
    if (selectionModel) {
      selectionModel.forEach((selection) => {
        const selectedRow = rows.filter((row) => row.id == selection);
        if (selectedRow.length != 0) {
          selectedRowsOnPageList.push(selectedRow[0]);
        }
      });
      setSelectedIds(selectedRowsOnPageList);
    }
    if (selectedIds.length === 1) {
      setPageChangeCheck(false);
    } else {
      setPageChangeCheck(true);
    }
  }, [rows]);

  const HandleSearch = (value) => {
    setCurrentPage(0);
    const payload = {
      currentPage: currentPage,
      pageSize: rowsPerPage,
      searchText: value,

      propertyName: "",
      direction: 1,
    };
    console.log("payload", payload);
    dispatch(getSparePartList(payload));
  };

  //go breakdown detail page
  const BackToBreakdownDetailPage = () => {
    props.history.goBack();
  };

  const GetSparePartMaxValue = (id) => {
    return sparePartList?.resultObject?.content.find(x => x.id === id).stockQuantity;
  }

  return (
    <Container maxWidth="m">
      <Grid id="bd_grid" container alignItems="center">
        <Grid id="bd_grid_1" item xs={1}>
          <IconButton
            id="bd_iconBtn"
            onClick={BackToBreakdownDetailPage}
            size="large"
          >
            <ArrowBackIos id="bd_arrowBack" fontSize="inherit" align="end" />
          </IconButton>
        </Grid>
        <Grid id="bd_grid_2" item xs={11}>
          <Typography
            id="bd_typ"
            variant="h6"
            gutterBottom
            style={{ fontSize: 20 }}
          >
            {props.title} {t("SparePartsSelection")}{" "}
          </Typography>
        </Grid>
        <React.Fragment>
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={1} />
            <Grid item xs={11} sm={8} md={4} lg={4}>
              <SearchBar
                value={filterText}
                onChange={(val) => setFilterText(val)}
                onRequestSearch={(value) => HandleSearch(value)}
              />
            </Grid>
          </Grid>
        </React.Fragment>
      </Grid>
      <Grid container sx={{ marginTop: 4 }}>
        <Grid item xs={12} sm={12} md={12} lg={6}>
          <Grow
            in={true}
            style={{ transformOrigin: "0 0 0" }}
            {...{ timeout: 1000 }}
          >
            <div style={{ width: "100%", textAlign: "center" }}>
              <DataGrid
                keepNonExistentRowsSelected
                style={{ maxHeight: window.innerHeight * 0.8 }}
                checkboxSelection
                onSelectionModelChange={(newSelectionModel) => {
                  setSelectionModel(newSelectionModel);
                }}
                selectionModel={selectionModel}
                autoHeight={true}
                rows={rows}
                columns={getSparePartColumns()}
                pageSize={rowsPerPage}
                onPageSizeChange={HandleChangeRowsPerPage}
                onPageChange={HandleChangePage}
                rowsPerPageOptions={[5, 10]}
                rowCount={rowsLength} //total count
                page={currentPage}
                paginationMode="server"
                disableColumnFilter
                disableColumnMenu
                getRowId={(row) => row.id}
                sortingMode="server"
                onSortModelChange={(sortModel) => handleSortDg(sortModel)}
                components={{
                  Toolbar: customToolbar,
                }}
                filterMode="server"
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                  handleChangeVisibility(newModel)
                }
                sx={{
                  boxShadow: 5,
                  "& .MuiDataGrid-row:hover": {
                    color: "primary.main",
                  },
                  "& .MuiDataGrid-columnSeparator": {
                    display: "none",
                  },
                }}
                localeText={{
                  toolbarColumns: t("Columns"),
                  columnsPanelTextFieldLabel: t("ColumnsPanelTextFieldLabel"),
                  columnsPanelTextFieldPlaceholder: t(
                    "ColumnsPanelTextFieldPlaceholder"
                  ),
                  columnsPanelShowAllButton: t("ColumnsPanelShowAllButton"),
                  columnsPanelHideAllButton: t("ColumnsPanelHideAllButton"),
                  toolbarDensity: t("Density"),
                  toolbarDensityCompact: t("DensityCompact"),
                  toolbarDensityStandard: t("DensityStandard"),
                  toolbarDensityComfortable: t("DensityComfortable"),
                }}
              />
            </div>
          </Grow>
        </Grid>
        {isMobile ? (
          <Grid item xs={1} sm={1} md={1} lg={1} style={{ marginLeft: "50%" }}>
            <KeyboardDoubleArrowDownIcon
              style={{ fontSize: 30, marginTop: "50%" }}
            />
          </Grid>
        ) : (
          <Grid item xs={1} sm={1} md={1} lg={1}>
            <KeyboardDoubleArrowRightIcon
              style={{ fontSize: 50, marginTop: "100%" }}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={12} lg={5}>
          <Grow
            in={true}
            style={{ transformOrigin: "0 0 0" }}
            {...{ timeout: 1000 }}
          >
            <TableContainer
              id="sp_TableContainer"
              component={Paper}
              style={{ maxHeight: window.innerHeight * 0.67, height: "700px" }}
            >
              <Table id="sp_Table" aria-label="customized table">
                <TableHead id="sp_TableHead">
                  <TableRow id="sp_TableRow">
                    {renderTableCell([
                      { id: "materialCode", label: t("StockNo") },
                      {
                        id: "materialDescription",
                        label: t("MaterialDescription"),
                      },
                      { id: "stockQuantity", label: t("WareHouseQuantity") },
                      { id: "Actions", label: t("Actions") },
                    ])}
                  </TableRow>
                </TableHead>
                <TableBody id="sp_TableBody">
                  {tempList.map((row, index) => (
                    <TableRow id={`sp_TableRow_${index}`} key={row.id}>
                      <TableCell id={`sp_TableCell_1_${index}`} align="center">
                        {row.materialCode}
                      </TableCell>
                      <TableCell id={`sp_TableCell_2_${index}`} align="center">
                        {row.materialDescription}
                      </TableCell>
                      <TableCell id={`sp_TableCell_5_${index}`} align="center">
                        <TextField
                          onChange={(e) => handleQuantityChange(e, row)}
                          type="number"
                          id={`be_TableCell_1_TextField_${index}`}
                          defaultValue={row.stockQuantity}
                          variant="standard"
                          inputProps={{
                            min: 0,
                            max: GetSparePartMaxValue(row.id),
                            style: { textAlign: "center", width: "60px" },
                          }}
                        />
                      </TableCell>
                      <TableButtons
                        table={"SparePart"}
                        deleteButtonHandler={() => deleteButtonHandler(row)}
                      />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grow>
          <Button
            id="of_button"
            onClick={handleSaveSparePart}
            style={{ marginTop: 12 }}
            variant="contained"
            color="primary"
          >
            {t("Save")}
          </Button>
        </Grid>
      </Grid>
      <Modal
        title={t("Delete")}
        content={t("WillYouDoTransaction")}
        approved={() => deleteHandler(deletedRow)}
        isModalOpen={isModalOpen}
        toggle={toggleModal}
      />
    </Container>
  );
}
